export default {module:'Card/Form',view:'Element/Section',children:[]}